export const Users = [
  {
    id:1,
    profilePicture: "person/1.jpeg",
    username: "ŖąĵŌŋ",
  },
  {
    id:2,
    profilePicture: "person/Andy.jpeg",
    username: "Andres Trutsi",
  },
  {
    id:3,
    profilePicture: "person/Dipok.jpeg",
    username: "Dipok Sarker",
  },
  {
    id:4,
    profilePicture: "person/4.jpeg",
    username: "Dora Hawks",
  },
  {
    id:5,
    profilePicture: "person/5.jpeg",
    username: "Jessica Rodriguez",
  },
  {
    id:6,
    profilePicture: "person/6.jpeg",
    username: "Linda Wilson",
  },
  {
    id:7,
    profilePicture: "person/7.jpeg",
    username: "Neil Pearson",
  },
  {
    id:8,
    profilePicture: "person/8.jpeg",
    username: "Anna Flick",
  },
  {
    id:9,
    profilePicture: "person/9.jpeg",
    username: "Sarah O'Connor",
  },
  {
    id:10,
    profilePicture: "person/10.jpeg",
    username: "Katerina Anderson",
  },
];

export const Posts = [
  {
    id: 1,
    desc: "I've finally learned what upward compatible means. It means we get to keep all our old mistakes.",
    photo: "post/1.jpeg",
    date: "5 mins ago",
    userId: 1,
    like: 32,
    comment: 9,
  },
  {
    id: 2,
    photo: "post/2.jpeg",
    date: "15 mins ago",
    userId: 2,
    like: 2,
    comment: 1,
  },
  {
    id: 3,
    desc: "If debugging is the process of removing bugs, then programming must be the process of putting them in.",
    photo: "post/4.jpeg",
    date: "1 hour ago",
    userId: 3,
    like: 61,
    comment: 2,
  },
  {
    id: 4,
    photo: "post/5.jpeg",
    date: "4 hours ago",
    userId: 4,
    like: 7,
    comment: 3,
  },
  {
    id: 5,
    photo: "post/13.jpeg",
    date: "5 hours ago",
    userId: 5,
    like: 23,
    comment: 5,
  },
  {
    id: 6,
    photo: "post/6.jpeg",
    date: "1 day ago",
    userId: 6,
    like: 44,
    comment: 6,
  },
  {
    id: 7,
    desc: "It's not a bug — it's an undocumented feature.",
    photo: "post/7.jpeg",
    date: "2 days ago",
    userId: 7,
    like: 52,
    comment: 3,
  },
  {
    id: 8,
    photo: "post/8.jpeg",
    date: "3 days ago",
    userId: 8,
    like: 15,
    comment: 1,
  },
  {
    id: 9,
    desc: "One man's crappy software is another man's full-time job.",
    photo: "post/9.jpeg",
    date: "5 days ago",
    userId: 9,
    like: 11,
    comment: 2,
  },
  {
    id: 10,
    photo: "post/11.jpeg",
    date: "1 week ago",
    userId: 10,
    like: 104,
    comment: 12,
  },
];
